// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Element.dataset notation polyfill for IE10. Needed for v-mask
// See https://github.com/probil/v-mask/issues/39
// Can be removed if the PR that fixes this ever gets merged
// Also see https://github.com/epiloque/element-dataset/issues/10 for weird require usage
require('element-dataset').default()

// Polyfill ES6 Promises for vee-validate
// https://github.com/stefanpenner/es6-promise
require('es6-promise').polyfill()

import Vue from 'vue'
import RfForm from './RfForm'
import RfText from './components/RfText'
import RfTextarea from './components/RfTextarea'
import RfSection from './components/RfSection'
import RfSectionNav from './components/RfSectionNav'
import RfSelect from './components/RfSelect'
import RfMultiple from './components/RfMultiple'
import RfStatus from './components/RfStatus'
import RfMessage from './components/RfMessage'
import RfDatepicker from './components/RfDatepicker'
import RfExpandFade from './components/RfExpandFade'
import RfRange from './components/RfRange'

// Register all our components globally
Vue.component('rf-form', RfForm)
Vue.component('rf-text', RfText)
Vue.component('rf-textarea', RfTextarea)
Vue.component('rf-multiple', RfMultiple)
Vue.component('rf-section', RfSection)
Vue.component('rf-section-nav', RfSectionNav)
Vue.component('rf-select', RfSelect)
Vue.component('rf-status', RfStatus)
Vue.component('rf-message', RfMessage)
Vue.component('rf-datepicker', RfDatepicker)
Vue.component('rf-expand-fade', RfExpandFade)
Vue.component('rf-range', RfRange)

// Icons
import 'vue-awesome/icons/exclamation-triangle'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/caret-down'
import 'vue-awesome/icons/caret-left'
import 'vue-awesome/icons/caret-right'
import 'vue-awesome/icons/ban'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

Vue.config.productionTip = process.env.NODE_ENV === 'development'

// Make Vue available globally so we can instantiate wherever we're using RF
window.Vue = Vue



// WEBPACK FOOTER //
// ./src/frontend/main.js